export const lg = {
    login: {
        col1: {
            style: {
                textAlign: 'right'
            },
            div1: {
                style: {
                    height: '57px'
                },
                button: {
                    style: {
                        position: 'absolute',
                        top: '21px',
                        right: '4px',
                        width: '150px'
                    }
                }
            },
            div2: {
                style: {
                    height: '57px'
                },
                button: {
                    style: {
                        position: 'absolute',
                        top: '60px',
                        right: '4px',
                        width: '150px'
                    }
                }
            }
        },
        col2: {
            style: {
                height: '114px',
                left: '4px'
            },
            div1: {
                style: {
                    position: 'relative',
                    height: '57px',
                    display: 'table',
                    top: '8px'
                }
            },
            div2: {
                style: {
                    position: 'relative',
                    height: '57px',
                    display: 'table',
                    top: '-11px'
                }
            }
        }
    },
    home: {
        col1: {
            style: {
                height: '114px',
                textAlign: 'center',
                display: 'table'
            },
            button: {
                style: {
                    width: '150px',
                    borderRadius: '40px'
                }
            }
        }
    },
    user: {
        row1: {
            style: {
                height: '114px',
                textAlign: 'right'
            },
            col1: {
                style: {
                    top: '17px'
                },
                img: {
                    style: {
                        width: '80px',
                        height: '80px'
                    }
                }
            }
        }
    }
};

export const md = {
    login: {
        col1: {
            style: {
                textAlign: 'right'
            },
            div1: {
                style: {
                    height: '57px'
                },
                button: {
                    style: {
                        position: 'absolute',
                        top: '13px',
                        right: '4px',
                        height: '30px',
                        width: '150px'
                    }
                }
            },
            div2: {
                style: {
                    height: '57px'
                },
                button: {
                    style: {
                        position: 'absolute',
                        top: '51px',
                        right: '4px',
                        height: '30px',
                        width: '150px'
                    }
                }
            }
        },
        col2: {
            style: {
                height: '94px',
                left: '4px'
            },
            div1: {
                style: {
                    position: 'relative',
                    height: '57px',
                    display: 'table',
                    top: '-1px'
                }
            },
            div2: {
                style: {
                    position: 'relative',
                    height: '57px',
                    display: 'table',
                    top: '-20px'
                }
            }
        }
    },
    home: {
        col1: {
            style: {
                height: '94px',
                textAlign: 'center',
                display: 'table'
            },
            button: {
                style: {
                    width: '150px',
                    borderRadius: '40px'
                }
            }
        }
    },
    user: {
        row1: {
            style: {
                height: '94px',
                textAlign: 'right'
            },
            col1: {
                style: {
                    top: '13px'
                },
                img: {
                    style: {
                        width: '70px',
                        height: '70px'
                    }
                }
            }
        }
    }
};

export const sm = {
    login: {
        col1: {
            style: {
                textAlign: 'right'
            },
            div1: {
                style: {
                    height: '37px'
                },
                button: {
                    style: {
                        position: 'absolute',
                        top: '10px',
                        right: '4px',
                        height: '24px',
                        width: '150px'
                    }
                }
            },
            div2: {
                style: {
                    height: '37px'
                },
                button: {
                    style: {
                        position: 'absolute',
                        top: '40px',
                        right: '4px',
                        height: '24px',
                        width: '150px'
                    }
                }
            }
        },
        col2: {
            style: {
                height: '74px', left: '4px'
            },
            div1: {
                style: {
                    position: 'relative',
                    height: '37px',
                    display: 'table',
                    top: '3px'
                }
            },
            div2: {
                style: {
                    position: 'relative',
                    height: '37px',
                    display: 'table',
                    top: '-5px'
                }
            }
        }
    },
    home: {
        col1: {
            style: {
                height: '74px',
                textAlign: 'center',
                display: 'table'
            },
            button: {
                style: {
                    height: '26px',
                    width: '150px',
                    borderRadius: '40px'
                }
            }
        }
    },
    user: {
        row1: {
            style: {
                height: '74px',
                textAlign: 'right'
            },
            col1: {
                style: {
                    top: '4px'
                },
                img: {
                    style: {
                        width: '55px',
                        height: '55px'
                    }
                }
            }
        }
    }
};

export const xs = {
    login: {
        col1: {
            style: {
                textAlign: 'right'
            },
            div1: {
                style: {
                    height: '27px'
                },
                button: {
                    style: {
                        position: 'absolute',
                        fontSize: '11px',
                        top: '5px',
                        right: '4px',
                        height: '20px',
                        width: '150px'
                    }
                }
            },
            div2: {
                style: {
                    height: '27px'
                },
                button: {
                    style: {
                        position: 'absolute',
                        fontSize: '11px',
                        top: '29px',
                        right: '4px',
                        height: '20px',
                        width: '150px'
                    }
                }
            }
        },
        col2: {
            style: {
                height: '54px', left: '4px'
            },
            div1: {
                style: {
                    position: 'relative',
                    height: '27px',
                    display: 'table',
                    top: '0px'
                }
            },
            div2: {
                style: {
                    position: 'relative',
                    height: '27px',
                    display: 'table',
                    top: '-3px'
                }
            }
        }
    },
    home: {
        col1: {
            style: {
                height: '54px',
                textAlign: 'center',
                display: 'table',
                marginTop: '-5px'
            },
            button: {
                style: {
                    hight: '24px',
                    width: '150px',
                    borderRadius: '40px'
                }
            }
        }
    },
    user: {
        row1: {
            style: {
                height: '54px',
                textAlign: 'right'
            },
            col1: {
                style: {
                    top: '-6px'
                },
                img: {
                    style: {
                        width: '40px',
                        height: '40px'
                    }
                }
            }
        }
    }
};
